import { render, staticRenderFns } from "./FormMenu.vue?vue&type=template&id=c4bd89a0&scoped=true&"
import script from "./FormMenu.vue?vue&type=script&lang=js&"
export * from "./FormMenu.vue?vue&type=script&lang=js&"
import style0 from "./FormMenu.vue?vue&type=style&index=0&id=c4bd89a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4bd89a0",
  null
  
)

export default component.exports